import { render, staticRenderFns } from "./SingleText.vue?vue&type=template&id=f60b9bb6&"
import script from "./SingleText.vue?vue&type=script&lang=js&"
export * from "./SingleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports